import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {FC, lazy, Suspense, useContext, useEffect} from "react";
import {UseCasesContext} from "../../../context/useCases";


const SuspenseComponent: FC<{ children: JSX.Element }> = ({children}) => (<Suspense fallback={<>Загрузка</>}>
    {children}
</Suspense>)

const TabelLazy = lazy(() => import("../../pages/tabel")
    .then(({Tabel}) => ({default: Tabel})));
const LoginLazy = lazy(() => import("../../pages/auth/login/login")
    .then(({Login}) => ({default: Login})));
const ChangePassLazy = lazy(() => import("../../pages/users/change-pass")
    .then(({ChangePass}) => ({default: ChangePass})));
const CalcParamsLazy = lazy(() => import("../../pages/calcparams/info")
    .then(({CalcParamsInfo}) => ({default: CalcParamsInfo})));
const CalcParamsUpdateLazy = lazy(() => import("../../pages/calcparams/calcparams_update/calcparams_update")
    .then(({CalcParamsUpdate}) => ({default: CalcParamsUpdate})));
const ReportLazy = lazy(() => import("../../pages/report")
    .then(({Report}) => ({default: Report})));
const HeadsZpLazy = lazy(() => import("../../pages/heads_zp")
    .then(({HeadsZp}) => ({default: HeadsZp})));
const LearnZpLazy = lazy(() => import("../../pages/learn_zp")
    .then(({LearnZp}) => ({default: LearnZp})));
const RooZpLazy = lazy(() => import("../../pages/roo_zp")
    .then(({RooZp}) => ({default: RooZp})));
const TeamleadZpLazy = lazy(() => import("../../pages/teamlead-zp")
    .then(({TeamleadZp}) => ({default: TeamleadZp})));
const SettingsLazy = lazy(() => import("../../pages/settings")
    .then(({Settings}) => ({default: Settings})));
const UserListLazy = lazy(() => import("../../pages/users/list")
    .then(({UserList}) => ({default: UserList})));
const UserAddLazy = lazy(() => import("../../pages/users/add")
    .then(({UserAdd}) => ({default: UserAdd})));


export const RouterComponent = () => {
    let useCases = useContext(UseCasesContext)

    const login = useTypedSelector(({login}) => {
        return login
    })

    useEffect(() => {
        useCases?.authUseCase.CheckAuthorization()
        setInterval(() => {
            useCases?.authUseCase.CheckAuthorization()
        }, 10000)
    }, [])


    return (
        <Suspense fallback={<>Загрузка</>}>
            <Router basename="/">
                <Routes>
                    {login?.authorized ?
                        <>
                            <Route path="/tabel" element={<SuspenseComponent><TabelLazy/></SuspenseComponent>}/>

                            <Route path="/heads-zp" element={<SuspenseComponent><HeadsZpLazy/></SuspenseComponent>}/>
                            <Route path="/learn-zp" element={<SuspenseComponent><LearnZpLazy/></SuspenseComponent>}/>
                            <Route path="/roo-zp" element={<SuspenseComponent><RooZpLazy/></SuspenseComponent>}/>
                            <Route path="/teamlead-zp"
                                   element={<SuspenseComponent><TeamleadZpLazy/></SuspenseComponent>}/>
                            <Route path="/settings" element={<SuspenseComponent><SettingsLazy/></SuspenseComponent>}/>
                            <Route path="/calc-params/edit"
                                   element={<SuspenseComponent><CalcParamsUpdateLazy/></SuspenseComponent>}/>
                            <Route path="/calc-params"
                                   element={<SuspenseComponent><CalcParamsLazy/></SuspenseComponent>}/>
                            <Route path="/user/password/:id"
                                   element={<SuspenseComponent><ChangePassLazy/></SuspenseComponent>}/>
                            <Route path="/user/edit/:id" element={<SuspenseComponent><UserAddLazy/></SuspenseComponent>}/>
                            <Route path="/user/add" element={<SuspenseComponent><UserAddLazy/></SuspenseComponent>}/>
                            <Route path="/user" element={<SuspenseComponent><UserListLazy/></SuspenseComponent>}/>

                            <Route path="*" element={useCases?.authUseCase.IsHr() ?
                                <SuspenseComponent><TabelLazy/></SuspenseComponent> :
                                <SuspenseComponent><ReportLazy/></SuspenseComponent>}/>
                        </>
                        : <>
                            <Route path="*" element={<SuspenseComponent><LoginLazy/></SuspenseComponent>}/>
                        </>}
                </Routes>
            </Router>
        </Suspense>
    )
}